/**
 * Default: Vendors > Mindshape Cookie consent
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

// -------
// Private
// -------

const callNewsflash = () => {
	if (undefined !== window.pageInstance.newsflash) {
		window.pageInstance.newsflash.render(true);
	}
};

const checkCatMedia = (consent) => {
	if (consent && typeof consent.hasOption !== 'function') {
		return;
	}

	// Youtube
	const allowedYoutube = consent.hasOption('youtube');
	const collectionYoutube = SelectorEngine.find('[data-player-type="youtube"]');

	for (const element of collectionYoutube) {
		EventHandler.trigger(element, `${allowedYoutube ? 'disable' : 'enable'}.privacyMode`);
	}

	// Vimeo
	const allowedVimeo = consent.hasOption('vimeo');
	const collectionVimeo = SelectorEngine.find('[data-player-type="vimeo"]');

	for (const element of collectionVimeo) {
		EventHandler.trigger(element, `${allowedVimeo ? 'disable' : 'enable'}.privacyMode`);
	}

	// Googlemap
	const allowedGooglemaps = consent.hasOption('googlemaps');
	const collectionGooglemaps = SelectorEngine.find('[data-gmap]');

	for (const element of collectionGooglemaps) {
		EventHandler.trigger(element, `${allowedGooglemaps ? 'disable' : 'enable'}.privacyMode`);
	}
};

// ------
// Public
// ------

const init = async () => {
	// Event wird nach dem Speichern etc. vom Consent-Plugin getriggert.
	window.addEventListener('cookieConsent', function (event) {
		// Prüfe (Übergabe Object `event.detail`)
		checkCatMedia(event.detail);

		// Newsflash triggern!
		callNewsflash();
	});

	if (window.cookieConsent.consent) {
		// Consent vorhanden.

		// Prüfe (Übergabe Object `window.cookieConsent`)
		checkCatMedia(window.cookieConsent);

		// Newsflash triggern!
		callNewsflash();
	} else {
		// Noch kein Consent vorhanden.
	}
};

// Export
export default init;
